module.exports = __webpack_public_path__ + "stockLibrary/landing-modal-img-5-02569a4fa9f10db1b6e234f9803c4d60.png";